import Icon from '../components/Icon.vue'

Icon.register({
  tram: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M288 64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zM511.5 51.9c2.2 8.5-2.8 17.3-11.4 19.6l-228.1 60.8v91.7h176c17.7 0 32 14.3 32 32v224c0 17.7-14.3 32-32 32h-384c-17.7 0-32-14.3-32-32v-224c0-17.7 14.3-32 32-32h176v-83.2l-219.9 58.7c-1.3 0.3-2.7 0.5-4.1 0.5-7.1 0-13.5-4.7-15.4-11.8-2.3-8.6 2.8-17.3 11.3-19.6l480-128c8.6-2.3 17.3 2.7 19.6 11.3zM176 384v-96h-96v96h96zM336 288v96h96v-96h-96zM304 288h-96v96h96v-96zM192 96c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/tram.js
// module id = 2026
// module chunks = 0